import React, { useState, useEffect } from "react";

import { translate } from "react-i18next";

import sdk from "src/sdk";

import styled from "react-emotion";

import { Box } from "src/components";
import { Button } from "src/components/Form";

const Iframe = styled.iframe({
  borderWidth: 0,
  width: "100%",
  minHeight: 350,
});

const Disclosure = ({ t, ...props }) => {
  const [disclosureUrl, setDisclosureUrl] = useState(null);

  const [loaded, setLoaded] = useState(false);

  const acceptDisclosure = () => {
    props.setEnrollmentState({
      ...props.enrollmentState,
      showDisclosureInterrupt: false,
    });
  };

  useEffect(() => {
    sdk.getDisclosureUrl().then(({ data: { disclosureUrl } }) => {
      setDisclosureUrl(disclosureUrl);
    });
  }, []);

  return (
    <Box>
      <Box mx={[-3, -3, 0]} mb={[0, 3]} style={{ minHeight: 400 }}>
        {disclosureUrl ? (
          <Iframe
            id="enrollment-disclosure-iframe"
            src={disclosureUrl}
            onLoad={() => setLoaded(true)}
            style={{ minWidth: "80%" }}
          />
        ) : null}
      </Box>
      {loaded ? (
        <Box pb={3}>
          <Button
            width={1}
            onClick={acceptDisclosure}
            title={t("olb.acceptDisclosureButton", {
              defaultValue: "Accept Disclosure",
            })}
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default translate("translations")(Disclosure);



// WEBPACK FOOTER //
// ./src/banking/authentication/Enroll/Disclosure.js